import React from 'react'
import { PositionsMain } from './components/PositionsMain'
import { PositionsProvider } from './context/PositionsProvider'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'

export const Positions = () => {
  return (
    <NuqsAdapter>
      <PositionsProvider>
        <PositionsMain />
      </PositionsProvider>
    </NuqsAdapter>
  )
}
